<template>
    <v-container fluid grid-list-md>
        <units></units>
    </v-container>
</template>
<script>
import Units from '../components/Units/List.vue';

export default {
    components: {
        Units
    }
};
</script>
